var map = {
	"./404.jpg": 827,
	"./Blog-01/ZTSS23_LOOK12-01.png": 6972,
	"./Blog-01/ZTSS23_LOOK14-01.png": 3850,
	"./Blog-01/ZTSS23_LOOK20-01.jpg": 4189,
	"./Blog-01/ZTSS23_LOOK7-05.png": 1542,
	"./Blog-01/ZTSS23_LOOK9-02.png": 7719,
	"./Blog-01/ZeynepTosun-BeyazGunes.jpg": 8588,
	"./Blog-01/ZeynepTosun-Combin-Card.jpg": 7112,
	"./Blog-01/ZeynepTosun_Slider.png": 1532,
	"./Blog-02/1DA-21205G.jpg": 3773,
	"./Blog-02/1DA-9004.jpg": 9907,
	"./Blog-02/1XSJ-9914.jpg": 1665,
	"./Blog-02/Icon.png": 5646,
	"./Blog-02/MAJI.jpg": 4140,
	"./Blog-02/Oda-01.jpg": 3207,
	"./Blog-02/Oda-02.jpg": 6712,
	"./Blog-02/ROGASKA.jpg": 841,
	"./Blog-02/ROSENTHAL mini vase 1.jpg": 4938,
	"./Blog-02/VERSACE1.png": 3309,
	"./Blog-02/VERSACE2.png": 2102,
	"./Blog-02/VERSACE3.png": 1119,
	"./Blog-02/VERSACE4.jpg": 8148,
	"./Blog-02/VERSACE5.jpg": 9953,
	"./Blog-03/GT-Craft-Tech-Carousel-1.png": 4332,
	"./Blog-03/GT-Power-Meets-Grace-Carousel-2.jpg": 9349,
	"./Blog-03/GT-interni-pan.jpeg": 2052,
	"./Blog-03/GranTurismo-Celebration_GT One.jpg": 2692,
	"./Blog-03/Maserati-Banner.png": 8487,
	"./Blog-03/Maserati-Card.png": 3063,
	"./Blog-03/Maserati.png": 2574,
	"./Blog-04/CihanNACAR-001.jpg": 1253,
	"./Blog-04/image00001.jpg": 7103,
	"./Blog-04/image00004.jpg": 8422,
	"./Blog-04/image00005-Icon.jpg": 3905,
	"./Blog-04/image00005-Icon2.jpg": 1439,
	"./Blog-04/image00005.jpg": 8531,
	"./Blog-04/image00007.jpg": 625,
	"./Blog-04/image00009.jpg": 903,
	"./Blog-04/image00011.jpg": 6604,
	"./Blog-04/image00015.jpg": 1464,
	"./Blog-05/GlowingTrident.png": 5047,
	"./Blog-05/Maserati-Shop-Icon.png": 7253,
	"./Blog-05/Maserati-Shop-Slider.png": 525,
	"./Blog-05/MissionFromMars.png": 1091,
	"./Blog-05/NorthSailsX.png": 8049,
	"./Blog-06/Demet-Ozdemir-Cosmos-Head.jpg": 4461,
	"./Blog-06/Demet-Ozdemir-Cosmos.jpg": 9832,
	"./Blog-06/Hale-Larisa-Cihan-Nacar.jpg": 5528,
	"./Blog-06/Nursena-Say-Cihan-Nacar.jpg": 8597,
	"./Blog-06/Tuvana-Turkay-Cihan-Nacar.jpg": 2783,
	"./Default_8k_resolution_super_realistic_photo_dark_theme_sexy_fu_0_d3e517a2-a810-4bd2-83d6-588668ebd206_1.jpg": 4613,
	"./Maserati-Banner.png": 1492,
	"./Maserati-Card.png": 7796,
	"./Maserati.png": 1623,
	"./ShopAndMag-Logo-Header.png": 9917,
	"./ShopAndMag-Logo.png": 1463,
	"./ZeynepTosun-BeyazGunes.jpg": 7731,
	"./__COPS/ZeynepTosun-BeyazGunes-Card.jpg": 498,
	"./__COPS/ZeynepTosun-Combin-Card.jpg.png": 8768,
	"./__COPS/ZeynepTosun-Combin.png": 6934,
	"./__COPS/ZeynepTosun-Suda-Card.jpg": 7642,
	"./__COPS/ZeynepTosun-Suda.jpg": 9701,
	"./__COPS/ZeynepTosun-TuruncuPullu-Card.jpg": 9203,
	"./__COPS/ZeynepTosun-TuruncuPullu.jpg": 574,
	"./approach-img.jpg": 4365,
	"./banner-bg1.jpg": 4028,
	"./banner-bg2.png": 4595,
	"./banner-bg3.jpg": 5585,
	"./banner-site-img1.png": 9742,
	"./banner-site-img2.png": 8517,
	"./banner-six.png": 9622,
	"./bg-1.jpg": 5420,
	"./bg-2.jpg": 75,
	"./bg-3.jpg": 2030,
	"./black-banner-nine.png": 5846,
	"./blog-details.jpg": 1206,
	"./blog/blog-1.jpg": 3086,
	"./blog/blog-10.jpg": 2948,
	"./blog/blog-11.jpg": 321,
	"./blog/blog-12.jpg": 8902,
	"./blog/blog-2.jpg": 9225,
	"./blog/blog-3.jpg": 1852,
	"./blog/blog-4.jpg": 5639,
	"./blog/blog-5.jpg": 6634,
	"./blog/blog-6.jpg": 7621,
	"./blog/blog-7.jpg": 4331,
	"./blog/blog-8.jpg": 9443,
	"./blog/blog-9.jpg": 8390,
	"./blog/blog-comment-1.jpg": 9326,
	"./blog/blog-comment-2.jpg": 5465,
	"./blog/blog-comment-3.jpg": 8092,
	"./blog/popular-posts-1.png": 9369,
	"./blog/popular-posts-2.png": 3282,
	"./blog/popular-posts-3.png": 4411,
	"./blog/popular-posts-4.png": 4500,
	"./blog/workplace.jpg": 714,
	"./choose-bg.jpg": 8738,
	"./choose-img.png": 6018,
	"./choose-us/choose-1.jpg": 5765,
	"./choose-us/choose-2.jpg": 3690,
	"./choose-us/choose-3.jpg": 1431,
	"./choose-us/choose-4.jpg": 3532,
	"./choose-us/choose-5.jpg": 409,
	"./clients/client-1.jpg": 8823,
	"./clients/client-2.jpg": 2488,
	"./clients/client-3.jpg": 3157,
	"./clients/client-4.jpg": 7534,
	"./clients/client-5.jpg": 5579,
	"./clients/client-6.jpg": 924,
	"./clients/client-bg.jpg": 3505,
	"./complete-img.jpg": 1096,
	"./complete-shape.png": 1322,
	"./cybersecurity-img-2.jpg": 8929,
	"./cybersecurity-img-3.jpg": 884,
	"./cybersecurity-img.jpg": 5608,
	"./electronic-img.png": 1807,
	"./faq-img.jpg": 385,
	"./finger.png": 4144,
	"./footer-bg.jpg": 6976,
	"./graph-img.png": 6237,
	"./hero-slider-1.jpg": 2987,
	"./hero-slider-2.jpg": 1468,
	"./language/arab.png": 7754,
	"./language/china.png": 8497,
	"./language/english.png": 4964,
	"./language/germany.png": 8155,
	"./language/portugal.png": 6172,
	"./link/Star.png": 3272,
	"./link/Star_pin_off.png": 6710,
	"./logo-black.png": 5408,
	"./logo.png": 2806,
	"./manual-img.png": 7107,
	"./more-home/banner/banner-1.jpg": 6714,
	"./more-home/banner/banner-2.jpg": 4565,
	"./more-home/banner/banner-bg.jpg": 3802,
	"./more-home/banner/black-banner.png": 7746,
	"./more-home/banner/line-bg.png": 5530,
	"./more-home/banner/shape.png": 3227,
	"./more-home/cyber-defenses/cyber-defenses-1.png": 1648,
	"./more-home/cyber-defenses/cyber-defenses-2.jpg": 6243,
	"./more-home/cyber-defenses/cyber-defenses-3.jpg": 3078,
	"./more-home/cyber-defenses/cyber-defenses-4.jpg": 4541,
	"./more-home/cyber-defenses/cyber-defenses-5.jpg": 5312,
	"./more-home/cyber-defenses/cyber-defenses-shape.png": 5494,
	"./more-home/expert-team/expert-team.png": 8638,
	"./more-home/features/features-1.png": 544,
	"./more-home/features/features-2.png": 8875,
	"./more-home/features/features-3.png": 4658,
	"./more-home/footer/footer-shape-1.png": 8476,
	"./more-home/footer/footer-shape-2.png": 6583,
	"./more-home/home-control/home-control.jpg": 7702,
	"./more-home/latest-news/news-1.jpg": 446,
	"./more-home/latest-news/news-2.jpg": 7561,
	"./more-home/latest-news/news-3.jpg": 6508,
	"./more-home/latest-news/news-4.jpg": 2503,
	"./more-home/operation-center/operation-center.jpg": 7798,
	"./more-home/overview/overview-1.jpg": 7148,
	"./more-home/overview/overview-2.jpg": 9947,
	"./more-home/partner/partner1.svg": 3613,
	"./more-home/partner/partner2.svg": 4494,
	"./more-home/partner/partner3.svg": 9247,
	"./more-home/partner/partner4.svg": 7040,
	"./more-home/partner/partner5.svg": 3489,
	"./more-home/plans/shape.png": 3717,
	"./more-home/projects/projects-1.jpg": 1514,
	"./more-home/projects/projects-2.jpg": 5653,
	"./more-home/projects/projects-3.jpg": 4472,
	"./more-home/safer-world/safer-world-2.png": 8447,
	"./more-home/safer-world/safer-world.png": 7966,
	"./more-home/testimonials/shape.png": 2161,
	"./more-home/testimonials/testimonials-bg.jpg": 8114,
	"./more-home/website-security/security-shape-1.png": 3718,
	"./more-home/website-security/security-shape-2.png": 5341,
	"./page-banner-bg.png": 4395,
	"./partner/partner-1.png": 2608,
	"./partner/partner-10.png": 5282,
	"./partner/partner-11.png": 5787,
	"./partner/partner-12.png": 5616,
	"./partner/partner-13.png": 1865,
	"./partner/partner-14.png": 9446,
	"./partner/partner-2.png": 939,
	"./partner/partner-3.png": 6114,
	"./partner/partner-4.png": 973,
	"./partner/partner-5.png": 7076,
	"./partner/partner-6.png": 3935,
	"./partner/partner-7.png": 6998,
	"./partner/partner-8.png": 4305,
	"./partner/partner-9.png": 4088,
	"./performance-bg.jpg": 7389,
	"./pricing-shape.png": 9421,
	"./project-1.jpg": 4438,
	"./project-2.jpg": 2209,
	"./project-3.jpg": 3684,
	"./security-bg.jpg": 5757,
	"./services-details1.jpg": 85,
	"./services-details2.jpg": 3834,
	"./services-slider/services-1.png": 844,
	"./services-slider/services-2.png": 9319,
	"./services-slider/services-3.png": 1630,
	"./services-slider/services-4.png": 4097,
	"./services-slider/services-5.png": 7800,
	"./shape/shape-1.png": 4152,
	"./shape/shape-10.png": 5498,
	"./shape/shape-11.png": 3075,
	"./shape/shape-12.png": 5419,
	"./shape/shape-13.png": 5665,
	"./shape/shape-2.png": 7363,
	"./shape/shape-3.png": 3258,
	"./shape/shape-4.png": 7029,
	"./shape/shape-5.png": 1116,
	"./shape/shape-6.png": 3767,
	"./shape/shape-7.png": 1278,
	"./shape/shape-8.png": 7145,
	"./shape/shape-9.png": 2672,
	"./solution/bg.jpg": 1166,
	"./solution/solution-1.jpg": 4080,
	"./solution/solution-2.jpg": 4399,
	"./solution/solution-3.jpg": 8018,
	"./solution/solution-4.jpg": 1617,
	"./solution/solution-5.jpg": 1668,
	"./solution/solution-6.jpg": 4243,
	"./talk-bg.jpg": 7021,
	"./team/team-1.jpg": 7956,
	"./team/team-2.jpg": 8003,
	"./team/team-3.jpg": 6390,
	"./team/team-4.jpg": 3261,
	"./team/team-5.jpg": 7696,
	"./team/team-6.jpg": 4335,
	"./team/team-7.jpg": 4306,
	"./team/team-8.jpg": 5113,
	"./testimonials/testimonials-1.jpg": 8142,
	"./testimonials/testimonials-2.jpg": 8409,
	"./testimonials/testimonials-3.jpg": 7884,
	"./testimonials/testimonials-4.jpg": 9431,
	"./testimonials/testimonials-5.jpg": 8042,
	"./testimonials/testimonials-6.jpg": 3765,
	"./transform-img.jpg": 3797,
	"./video-img.png": 7464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;